import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import styles from './common.module.css'

interface Account {
  bank?: string
  accountNumber?: string
  accountHolder?: string
}

interface AccountsBlockProps extends BlockProps {
  layout?: 'list'
}

function AccountRow({ label, account }: { label: string; account: Account }) {
  return (
    <div className={styles.accountItem}>
      <span className={styles.contactLabel}>{label}</span>
      <span className={styles.accountInfo}>
        {account.bank}
        {account.accountNumber ? ` ${account.accountNumber}` : ''}
      </span>
      {account.accountHolder && (
        <span className={styles.accountLabel}>{account.accountHolder}</span>
      )}
    </div>
  )
}

function AccountGroup({ label, person }: { label: string; person: Record<string, unknown> | undefined }) {
  if (!person) return null
  const account = person.account as Account | undefined
  const parentAccounts = person.parentAccounts as
    | { father?: Account[]; mother?: Account[] }
    | undefined

  const fatherAccount = parentAccounts?.father?.[0]
  const motherAccount = parentAccounts?.mother?.[0]

  const hasData = !!(
    account?.bank ||
    fatherAccount?.bank ||
    motherAccount?.bank
  )
  if (!hasData) return null

  return (
    <div className={styles.contactGroup}>
      <span className={styles.accountLabel}>{label}</span>
      {account?.bank && <AccountRow label={label === '신랑 측' ? '신랑' : '신부'} account={account} />}
      {fatherAccount?.bank && <AccountRow label="아버지" account={fatherAccount} />}
      {motherAccount?.bank && <AccountRow label="어머니" account={motherAccount} />}
    </div>
  )
}

export function AccountsBlock({ invitation, activeSection, onSectionClick, mode }: AccountsBlockProps) {
  const groom = invitation.groom as Record<string, unknown> | undefined
  const bride = invitation.bride as Record<string, unknown> | undefined

  const groomAccount = groom?.account as Account | undefined
  const brideAccount = bride?.account as Account | undefined
  const groomParentAccounts = groom?.parentAccounts as { father?: Account[]; mother?: Account[] } | undefined
  const brideParentAccounts = bride?.parentAccounts as { father?: Account[]; mother?: Account[] } | undefined

  const hasAccountData = !!(
    groomAccount?.bank || groomAccount?.accountHolder ||
    brideAccount?.bank || brideAccount?.accountHolder ||
    groomParentAccounts?.father?.[0]?.bank || groomParentAccounts?.mother?.[0]?.bank ||
    brideParentAccounts?.father?.[0]?.bank || brideParentAccounts?.mother?.[0]?.bank
  )

  return (
    <SectionWrapper
      sectionId="accounts"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={styles.section}
    >
      <span className={styles.sectionTitle}>계좌번호</span>
      <div className={styles.divider} />
      {hasAccountData ? (
        <div className={styles.accountList}>
          <AccountGroup label="신랑 측" person={groom} />
          <AccountGroup label="신부 측" person={bride} />
        </div>
      ) : (
        <p className={styles.placeholderText}>계좌 정보가 여기에 표시됩니다</p>
      )}
    </SectionWrapper>
  )
}
